import { motion } from "framer-motion";
import { ShoppingBag, Zap, ShoppingCart, MessageCircle, Globe, ArrowUpRight } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { waLink, MARKETPLACES } from "../config";
import { scrollToHash } from "./Header";

export const WhereToBuy = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const channels = [
    { name: "Amazon", desc: "Shop the full range", icon: ShoppingBag, href: MARKETPLACES.amazon, external: true, testid: "buy-amazon-btn" },
    { name: "Instamart", desc: "Delivered in minutes", icon: Zap, href: MARKETPLACES.instamart, external: true, testid: "buy-instamart-btn" },
    { name: "Blinkit", desc: "Now on quick commerce", icon: ShoppingCart, href: MARKETPLACES.blinkit, external: true, testid: "buy-blinkit-btn" },
    { name: "WhatsApp", desc: "Order directly from us", icon: MessageCircle, href: waLink("Hi PHUDG! I'd like to place an order."), external: true, testid: "buy-whatsapp-btn" },
    { name: "This Website", desc: "Order online — UPI, cards or cash on delivery", icon: Globe, href: "/#oils", external: false, testid: "buy-website-btn" },
  ];

  const go = (ch) => {
    if (ch.external) {
      window.open(ch.href, "_blank", "noopener,noreferrer");
    } else if (location.pathname === "/") {
      scrollToHash("#oils");
    } else {
      sessionStorage.setItem("scrollToHash", "#oils");
      navigate("/");
    }
  };

  return (
    <section id="where-to-buy" data-testid="where-to-buy-section" className="bg-cream py-28 md:py-36 border-t border-ink/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-xs tracking-[0.4em] uppercase text-amberbrand mb-4"
        >
          04 — Where to Buy
        </motion.p>
        <div className="overflow-hidden mb-16">
          <motion.h2
            initial={{ y: "100%" }}
            whileInView={{ y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif text-5xl md:text-7xl text-ink tracking-tighter"
          >
            Get it <span className="italic text-olive">your way.</span>
          </motion.h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {channels.map((ch, i) => {
            const Icon = ch.icon;
            return (
              <motion.button
                key={ch.name}
                data-testid={ch.testid}
                onClick={() => go(ch)}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                whileHover={{ y: -8 }}
                className="group rounded-3xl border border-ink/10 bg-white/70 p-8 text-left transition-colors duration-300 hover:border-gold/60"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink text-cream group-hover:bg-gold group-hover:text-ink transition-colors duration-300">
                    <Icon size={20} />
                  </span>
                  <ArrowUpRight size={18} className="text-ink/30 group-hover:text-gold transition-colors duration-300" />
                </div>
                <h3 className="font-serif text-2xl text-ink mb-1">{ch.name}</h3>
                <p className="text-sm font-light text-ink/50">{ch.desc}</p>
                <p className="mt-5 text-[10px] tracking-[0.3em] uppercase text-amberbrand">Shop Now</p>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
